<template>
  <v-dialog v-model="dialog" :max-width="modalWidth">
    <v-btn slot="activator" class="mr-0" icon flat color="primary">
      <v-tooltip top>
        <slot><v-icon small slot="activator">edit</v-icon></slot>
        <span>Edit</span>
      </v-tooltip>
    </v-btn>
    <v-card class="rounded-card elevation-6 pa-3">
      <v-toolbar dark color="primary lighten-2 mb-1">
        <v-toolbar-title>Edit a member's details</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
        <v-card-text>
          <v-alert
            v-if="error"
            :value="true"
            type="error"
            icon="warning"
            class="mb-3"
          >
            {{ errorMessage }}
          </v-alert>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs10 sm6>
                <v-text-field
                  v-model="firstname"
                  class="ma-0"
                  prepend-icon="person_outline"
                  name="firstname"
                  label="First name"
                  type="text"
                  :rules="[v => !!v || 'First name is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm6>
                <v-text-field
                  v-model="lastname"
                  class="ma-0"
                  prepend-icon="blank"
                  name="lastname"
                  label="Last name"
                  type="text"
                  :rules="[v => !!v || 'Last name is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  v-model="email"
                  class="ma-0"
                  label="Email Address"
                  prepend-icon="blank"
                  name="email"
                  required
                  :rules="emailRules"
                  :error-messages="emailError"
                  type="email"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  v-model="mobile"
                  class="ma-0"
                  label="Mobile phone"
                  prepend-icon="blank"
                  name="mobile"
                  type="phone"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-if="!isYou(userId)"
                  class="ma-0"
                  v-model="owner"
                  prepend-icon="blank"
                  label="Is a team owner"
                ></v-checkbox>
                <v-checkbox
                  v-else
                  class="ma-0 pb-0"
                  v-model="owner"
                  disabled
                  prepend-icon="blank"
                  label="Is a team owner"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-5 mt-0 rounded-card">
          <v-btn
            v-if="isYou(this.userId)"
            class="hidden-xs-only"
            flat
            round
            text
            color="primary"
            @click="gotoProfile"
          >
            <span>Full Profile</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat round outline color="primary" @click="dialog = false">
            <span>Cancel</span>
          </v-btn>
          <v-btn
            :disabled="!valid"
            type="submit"
            round
            class="accent"
            :loading="loading"
            @click="submit"
          >
            <v-icon small left>save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
const MODAL_WIDTH = '600px';

export default {
  props: {
    member: { type: Object, default: null }
  },
  data: function() {
    return {
      owner: false,
      valid: false,
      error: false,
      errorMessage: 'Error.',
      emailError: null,
      email: null,
      conflictEmail: null,
      userId: null,
      firstname: null,
      lastname: null,
      // description: null,
      mobile: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid'
      ],
      loading: false,
      dialog: false,
      modalWidth: MODAL_WIDTH
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    dialog: function(visible, hidden) {
      if (visible) {
        this.modalWidth =
          window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
        this.error = false;
        this.errorMessage = null;
        this.emailError = null;
        this.conflictEmail = null;
        this.loading = false;
        this.$refs.form.resetValidation();
      }
    },
    email: function() {
      if (this.email !== this.conflictEmail) {
        this.emailError = null;
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isTeamOwner']),
    ...mapState('auth', ['team', 'user', 'users'])
  },
  mounted: async function() {
    this.userId = this.member._id;
    this.email = this.member.email;
    this.mobile = this.member.mobile;
    this.firstname = this.member.firstname;
    this.lastname = this.member.lastname;
    // this.description = this.member.description;
    this.owner = this.isATeamOwner(this.userId);
  },
  methods: {
    gotoProfile() {
      this.$router.push('/profile');
    },
    isATeamOwner(userId) {
      if (userId) {
        return !!this.team.owners.includes(userId);
      }
      return false;
    },
    isYou(userId) {
      return userId === this.user._id;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.error = false;
        this.loading = true;
        this.emailError = null;
        this.conflictEmail = null;
        const result = await this.updateProfile({
          userId: this.userId,
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          mobile: this.mobile,
          owner: this.owner
        });
        // eslint-disable-next-line
        // console.log('result -->', result);
        this.loading = false;
        if (result && result.error) {
          if (result.statusCode === 409) {
            this.conflictEmail = this.email;
            this.emailError =
              'Error! This email address is already assigned to another Groupmail account. Please choose a different address';
          } else if (result.statusCode === 401) {
            this.errorMessage = `Error! Apparently your token has expired (code: ${result.statusCode})`;
            this.error = true;
          } else {
            this.errorMessage = `Error! ${result.message} (code ${result.statusCode})`;
            this.error = true;
          }
        } else {
          this.setSnack('Member Updated');
          this.dialog = false;
          this.email = null;
          this.error = false;
          this.errorMessage = null;
          this.userId = null;
          this.email = null;
          this.mobile = null;
          this.firstname = null;
          this.lastname = null;
          this.owner = false;
          this.$refs.form.resetValidation();
        }
      }
    },
    ...mapActions({
      updateProfile: 'account/updateProfile',
      setSnack: 'snackbar/setSnack'
    })
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
